import React from 'react';
import { Typography } from '@mui/material';
import { useFieldHelper } from 'framework/ui/field';
import { DATE_FORMAT, useDateService } from 'framework/utils';
import { ProjectDashboardCycleStatus } from '../../ProjectDashboardService';

interface ProjectDashboardCyclePeriodFieldProps {
  sourceDateFrom: string;
  sourceDateTo: string;
  sourceCycleStatus: string;
  [key: string]: any;
}

const ProjectDashboardCyclePeriodField = ({
  sourceDateFrom,
  sourceDateTo,
  sourceCycleStatus,
}: ProjectDashboardCyclePeriodFieldProps) => {
  const { formatDate } = useDateService();
  const { getValue: getDateFrom } = useFieldHelper({ source: sourceDateFrom });
  const { getValue: getDateTo } = useFieldHelper({ source: sourceDateTo });
  const { getValue: getCycleStatus } = useFieldHelper({ source: sourceCycleStatus });
  const value = `${formatDate(getDateFrom(), DATE_FORMAT.FULL_DATE)} - ${formatDate(
    getDateTo(),
    DATE_FORMAT.FULL_DATE,
  )}`;

  const isFutureCycle = getCycleStatus() === ProjectDashboardCycleStatus.FUTURE;

  return (
    <Typography
      component="span"
      variant="inherit"
      data-cycle-status={isFutureCycle ? 'future' : 'current'}
      sx={isFutureCycle ? { color: 'text.secondary' } : undefined}
    >
      {value}
    </Typography>
  );
};

export default ProjectDashboardCyclePeriodField;
